import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import { Input } from '../../../../../library/common/html/input'
import {
  clearValidateNameCreatePortfolio,
  selectTextValidateNamePortfolio,
} from '../../store/slice'
import { postCreatePortfolio } from '../../store/thunk'
import { removeSpecials } from '../helper'

export const CreatePortfolio = ({
  isShow,
  setShow,
  handleAfterCreate,
  organizationIds,
}) => {
  const dispatch = useDispatch()

  const textValidate = useSelector(selectTextValidateNamePortfolio)

  const [value, setValue] = useState('')

  const handleCreateNewPortfolio = () => {
    dispatch(
      postCreatePortfolio({
        portfolioName: value.trim(),
        organizationIds,
      }),
    )
      .unwrap()
      .then(() => {
        setShow(false)
        handleAfterCreate && handleAfterCreate(value.trim())
      })
      .catch(() => {})
  }

  const handleChangeInput = (value) => {
    setValue(removeSpecials(value))
  }

  useEffect(() => {
    if (textValidate) {
      dispatch(clearValidateNameCreatePortfolio())
    }
  }, [value])

  return (
    <>
      {isShow && (
        <PopupAction
          appendStyle={{
            padding: '20px',
            backgroundColor: '#F3F3F3',
            width: 480,
            borderRadius: '4px',
          }}
          isShow={isShow}
          title="library.savePortfolio.CREATE_NEW_PORTFOLIO"
          handleClose={() => setShow(false)}
          btnSubmit={{
            label: 'library.main.CREATE',
            isI18n: true,
            event: () => {
              handleCreateNewPortfolio()
            },
            disabled: !value.trim(),
          }}
          btnCancel={{
            label: 'library.filterSetting.CANCEL',
            event: () => {
              setShow(false)
            },
            isI18n: true,
          }}
        >
          <Input
            placeHolder="library.savePortfolio.ENTER_NAME_PORTFOLIO"
            onChange={(value) => handleChangeInput(value)}
            onEnter={() => {
              handleCreateNewPortfolio()
            }}
            isRemoveSpecialCharacters={true}
            value={value}
          />
          {textValidate && (
            <>
              <Element
                elementName="p"
                style={{
                  fontStyle: 'italic',
                  color: '#E0505B',
                  paddingTop: 4,
                }}
              >
                {textValidate}
              </Element>
            </>
          )}
        </PopupAction>
      )}
    </>
  )
}

CreatePortfolio.propTypes = {
  handleAfterCreate: PropTypes.func,
  organizationIds: PropTypes.array,
}
CreatePortfolio.defaultProps = {
  handleAfterCreate: () => {},
  organizationIds: [],
}
